<h1>Åtkomst nekad!</h1>
<mat-dialog-content>
  <br />
  <h3>
    Du har ej nödvändig rättighet för åtkomst.
  </h3>
  <h3>
    Säkerställ med administratör om detta ej stämmer.
  </h3>
  <h3>
    Skulle problem kvarstå, vänligen kontakta support.
  </h3>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button type="button" color="primary" mat-dialog-close>Försök igen</button>
  <button mat-raised-button type="button" (click)="logout()" color="primary">Logga ut</button>
</mat-dialog-actions>
